import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../api/auth';
import { getApiErrorMessage } from '../api/http';
import { toEnglishUserMessage } from '../lib/messageI18n';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    setLoading(true);
    try {
      const res = await requestPasswordReset(email);
      if (res.success) {
        setSuccessMessage(
          toEnglishUserMessage(
            res.message || 'If an account exists for this email, we sent password reset instructions.',
          ),
        );
        setEmail('');
      } else {
        setError(toEnglishUserMessage(res.message || 'Request failed'));
      }
    } catch (err) {
      setError(getApiErrorMessage(err, 'Request failed'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-vh-100 d-flex flex-column" style={{ background: 'linear-gradient(180deg,#f8f9fe,#fff)' }}>
      <nav className="navbar navbar-dark public-hero">
        <div className="container">
          <Link className="navbar-brand" to="/">
            M3UStudio
          </Link>
          <Link className="btn btn-light btn-sm rounded-pill" to="/login">
            Sign in
          </Link>
        </div>
      </nav>
      <div className="flex-grow-1 d-flex align-items-center py-5">
        <div className="container" style={{ maxWidth: 440 }}>
          <div className="card shadow border-0 rounded-4 overflow-hidden">
            <div style={{ height: 4, background: 'linear-gradient(87deg,#5e72e4,#825ee4)' }} />
            <div className="card-body p-4">
              <p className="small text-uppercase text-primary fw-semibold mb-1">M3UStudio</p>
              <h1 className="h4 fw-bold mb-3">Forgot password</h1>
              <p className="small text-muted mb-3">
                Enter your account email. We will send you a link to reset your password.
              </p>
              {error && <div className="alert alert-danger py-2 small">{error}</div>}
              {successMessage && (
                <div className="alert alert-success py-2 small">{successMessage}</div>
              )}
              {!successMessage && (
                <form onSubmit={onSubmit}>
                  <div className="mb-4">
                    <label className="form-label" htmlFor="fp-email">
                      Email
                    </label>
                    <input
                      id="fp-email"
                      type="email"
                      className="form-control form-control-lg"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoComplete="email"
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary w-100 rounded-pill py-2" disabled={loading}>
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Sending…
                      </>
                    ) : (
                      'Send reset link'
                    )}
                  </button>
                </form>
              )}
              <p className="small text-center mt-3 mb-0">
                <Link to="/login">Back to sign in</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
